import { PinchZoomObserver } from './pinch-zoom-observer';
export class PinchZoomHandler {
    static create(element, elViewport) {
        if (element instanceof HTMLElement && elViewport instanceof HTMLElement) {
            return new PinchZoomHandler(element, elViewport);
        }
        console.warn(`Pinch Zoom not initialized, attached element is not an HTML element.`);
    }
    constructor(element, elViewport) {
        this.element = element;
        this.elViewport = elViewport;
        this.zoomChange = new PinchZoomObserver();
        this.scale = 1;
        this.minScale = 1;
        this.maxScale = 6;
        this.zoomStep = 0.1;
        this._isPan = false;
        this._start = { x: 0, y: 0 };
        this._offset = { x: 0, y: 0 }; // The transform offset (from center)
        // Event Handlers
        this.panStart = (event) => {
            event.preventDefault();
            this._isPan = true;
            this._start.x = event.clientX - this._offset.x;
            this._start.y = event.clientY - this._offset.y;
        };
        this.panMove = (event) => {
            if (!this._isPan) {
                return;
            }
            const elementRect = this.element.getBoundingClientRect();
            const elViewportRect = this.elViewport.getBoundingClientRect();
            let x = event.clientX - this._start.x;
            // x and y calculations to ensure the element cannot be removed from the viewport
            if ((elementRect.x >= elViewportRect.x && x >= this._offset.x) ||
                (elementRect.right <= elViewportRect.right && x <= this._offset.x)) {
                x = this._offset.x;
            }
            let y = event.clientY - this._start.y;
            if ((elementRect.y >= elViewportRect.y && y >= this._offset.y) ||
                (elementRect.bottom <= elViewportRect.bottom && y <= this._offset.y)) {
                y = this._offset.y;
            }
            this._offset.x = x;
            this._offset.y = y;
            this.element.style.translate = `${this._offset.x}px ${this._offset.y}px`;
        };
        this.panEnd = () => {
            this._isPan = false;
        };
        this.wheel = (event) => {
            event.preventDefault();
            if (event.deltaY < 0) {
                // Zoom in
                this.scale = Math.min(this.maxScale, this.scale + this.zoomStep);
            }
            else {
                // Zoom out
                this.scale = Math.max(this.minScale, this.scale - this.zoomStep);
                this.adjustItemPosition();
            }
            this.element.style.transform = `scale(${this.scale})`;
            this.updateCursorStyle();
            this.zoomChange.emit(this.scale);
        };
        this.addListeners();
    }
    zoomIn() {
        this.scale = Math.min(this.maxScale, this.scale + this.zoomStep);
        this.element.style.transform = `scale(${this.scale})`;
        this.updateCursorStyle();
        this.zoomChange.emit(this.scale);
    }
    zoomOut() {
        this.scale = Math.max(this.minScale, this.scale - this.zoomStep);
        this.element.style.transform = `scale(${this.scale})`;
        this.adjustItemPosition();
        this.updateCursorStyle();
        this.zoomChange.emit(this.scale);
    }
    reset() {
        // Size
        this.scale = 1;
        this.element.style.transform = `scale(${this.scale})`;
        this.toCenterItem();
        this.updateCursorStyle();
        this.zoomChange.emit(this.scale);
    }
    destroy() {
        this.removeListeners();
    }
    updateCursorStyle() {
        if (this.scale === this.minScale) {
            this.element.style.cursor = 'initial';
        }
        else {
            this.element.style.cursor = 'grab';
        }
    }
    toCenterItem() {
        this._offset.x = 0;
        this._offset.y = 0;
        this.element.style.translate = `0`;
    }
    adjustItemPosition() {
        const elementRect = this.element.getBoundingClientRect();
        const elViewportRect = this.elViewport.getBoundingClientRect();
        let x = this._offset.x;
        let y = this._offset.y;
        if (elementRect.width > elViewportRect.width) {
            if (elementRect.x >= elViewportRect.x) {
                x = (elementRect.width - elViewportRect.width) / this.scale;
            }
            if (elementRect.right < elViewportRect.right) {
                x = -(elementRect.width - elViewportRect.width) / this.scale;
            }
        }
        else {
            x = 0;
        }
        if (elementRect.height > elViewportRect.height) {
            if (elementRect.y > elViewportRect.y) {
                y = (elementRect.height - elViewportRect.height) / this.scale;
            }
            if (elementRect.bottom < elViewportRect.bottom) {
                y = -(elementRect.height - elViewportRect.height) / this.scale;
            }
        }
        else {
            y = 0;
        }
        this._offset.x = x;
        this._offset.y = y;
        this.element.style.translate = `${this._offset.x}px ${this._offset.y}px`;
    }
    addListeners() {
        this.elViewport.addEventListener('mousedown', this.panStart);
        this.elViewport.addEventListener('mousemove', this.panMove);
        this.elViewport.addEventListener('wheel', this.wheel);
        window.addEventListener('pointerup', this.panEnd);
    }
    removeListeners() {
        this.element.removeEventListener('pointerdown', this.panStart);
        this.element.removeEventListener('pointermove', this.panMove);
        this.elViewport.removeEventListener('wheel', this.wheel);
        window.removeEventListener('pointerup', this.panEnd);
    }
}
